<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>

        Add new
        <v-btn
          @click="newCustomer('Add new')"
          class="ma-2"
          outlined
          small
          fab
          color="indigo"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              v-if="item.index === 0"
              :headers="headers"
              :items="data"
              item-value="Id_No"
              :search="search"
              :custom-filter="filterOnlyCapsText"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr :key="item.CustCode" :class="checkDel(item)">
                  <td>{{ item.CustCode }}</td>
                  <td>{{ item.CustName }}</td>
                  <td>{{ item | formatAddress }}</td>
                  <td>{{ item.phone }}</td>

                  <td>{{ item.CustRoute }}</td>
                  <td>{{ item.RepName }}</td>

                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="getCustDetaiils(item.CustCode)"
                    >
                      Edit
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title>{{ dialogtitle }}</v-card-title>
        <v-card-text>
          <div v-if="dialogerror">
            <v-alert
              dismissible
              v-model="dialogerror"
              dense
              outlined
              type="error"
              >{{ dialogerror }}</v-alert
            >
          </div>
          <p v-if="customer.CustCode" class="mx-4">
            Code : {{ customer.CustCode }}
          </p>
          <v-text-field
            v-model.trim="customer.CustName"
            label="Customer Name"
            class="mx-4"
            :rules="[rules.required]"
          ></v-text-field>

          <v-text-field
            v-model.trim="customer.Address1"
            label="Address1"
            class="mx-4"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            v-model.trim="customer.Address2"
            label="Address2"
            class="mx-4"
          ></v-text-field>
          <v-text-field
            v-model.trim="customer.Address3"
            label="Address3"
            class="mx-4"
          ></v-text-field>
          <v-text-field
            v-model.trim="customer.phone"
            label="Phone"
            class="mx-4"
          ></v-text-field>
          <v-text-field
            v-model.trim="customer.CustRoute"
            label="CustRoute"
            class="mx-4"
            :rules="[rules.required]"
          ></v-text-field>
          <v-select
            v-model="customer.RepCode"
            item-text="RepName"
            item-value="RepCode"
            :items="reps"
            label="Rep"
            filled
          ></v-select>
          <v-checkbox
            v-model="customer.Delete"
            label="Delete/Disable"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="green darken-1" text @click="saveCustomer()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Decrypt } from "../../../lib/encryption";
import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";

export default {
  data() {
    return {
      reps: [],
      dialogtitle: "Edit Customer",
      dialogerror: null,
      search: "",
      overlay: true,
      name: "CUSTOMERS",
      dialog: false,
      tab: null,
      tabitems: [{ name: "Customers", index: 0 }],
      filter: "",
      data: [],
      errormessage: null,
      selectedrep: {},
      customer: {
        Id_No: 1,
        CustCode: "C001",
        CustName: "ARUNASIRI MOTORS-----",
        Address1: "HORANA",
        Address2: "",
        Address3: "HORANA",
        CustRoute: "HORANA, KESBEWA, RAJAGIRIYA, COLOMBO, KADAWATHA, R",
        Delete: false,
        Insertuser: "SHANAKA",
        InsertDate: "2015-11-20T17:13:48.310Z",
      },
      rules: {
        required: function (value) {
          return !!value || "Required.";
        },
      },
      headers: [
        {
          value: "CustCode",
          text: "Code",
          sortable: true,
        },
        {
          value: "CustName",
          text: "Customer Name",
          sortable: true,
        },
        {
          value: "Address1",
          text: "Address",
          sortable: true,
        },
        {
          value: "Phone",
          text: "phone",
          sortable: true,
        },
        {
          value: "CustRoute",
          text: "Route",
          sortable: true,
        },
        {
          value: "RepName",
          text: "Rep",
          sortable: true,
        },
        { value: "actions", text: "Actions" },
      ],
    };
  },
  methods: {
    newCustomer(type) {
      this.dialogtitle = type;
      this.customer = {};
      this.selectedrep = {};
      this.dialog = true;
    },
    log() {},
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },
    getreps() {
      HTTP.get(BASE_URL + `reps`)
        .then((response) => {
          if (response.data[0].success) {
            this.errormessage = null;
            this.reps = response.data[0].dataset;
          } else {
            if (!response.data[0].season) this.$router.push("/login");

            this.errormessage = response.data[0].message;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    saveCustomer() {
      let user = JSON.parse(Decrypt(localStorage.user));
      this.customer.InsertUser = user.User;

      HTTP.post(BASE_URL + `customer/`, this.customer)
        .then((response) => {
          if (response.data[0].success) {
            this.dialogerror = null;
            this.dialog = false;
            this.getCustomers();
            this.customer = {};
          } else {
            if (!response.data[0].season) this.$router.push("/login");
            this.dialogerror = response.data[0].message;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    getCustDetaiils(custcode) {
      this.dialogtitle = "Edit Customer";
      this.selectedrep - {};
      HTTP.get(BASE_URL + `customer/${custcode}`)
        .then((response) => {
          if (response.data[0].success) {
            {
              this.dialogerror = null;
              this.customer = response.data[0].dataset[0];
            }
          } else {
            if (!response.data[0].season) this.$router.push("/login");
            this.dialogerror = response.data[0].message;
          }
          this.dialog = true;
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },

    checkDel(item) {
      if (item.Delete) {
        return "deleted";
      } else return "";
    },
    getCustomers() {
      HTTP.get(BASE_URL + `customers/?q=` + this.filter)
        .then((response) => {
          // JSON responses are automatically parsed.
          if (response.data[0].success) {
            this.errormessage = null;
            this.data = response.data[0].dataset;
          } else {
            if (!response.data[0].season) this.$router.push("/login");
           
           this.errormessage = response.data[0].message;
          }
          this.overlay = false;
        })
        .catch((e) => {
          this.errormessage = e;
          this.overlay = false;
        });
      //console.log(this.data);
    },
  },
  filters: {
    formatAddress(v) {
      let addresss = [];
      if (v.Address1) addresss.push(v.Address1);
      if (v.Address2) addresss.push(v.Address2);
      if (v.Address3) addresss.push(v.Address3);
      return addresss.join(", ");
    },
  },
  // Fetches posts when the component is created.
  mounted() {
    this.getCustomers();
    this.getreps();
  },
  beforeCreate() {
    setAuthToken();
    this.customer = {};
    console.clear();
  },
};
</script>

<style scoped>
.deleted {
  color: red;
}
</style>
